export enum EventAttendeeStatus {
  ATTENDEE_STATUS_PASSED = 0,
  ATTENDEE_STATUS_NOT_REGISTERED = 1,
  ATTENDEE_STATUS_REGISTERED = 2
}
